// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4.97 3 L11.03 3 C11.72 3 12.34 3.41 12.61 4.04 L14.18 7.68 C14.39 8.16 14.5 8.68 14.5 9.2 L14.5 11.3 C14.5 12.24 13.74 13 12.8 13 L3.2 13 C2.26 13 1.5 12.24 1.5 11.3 L1.5 9.2 C1.5 8.68 1.61 8.16 1.82 7.68 L3.39 4.04 C3.66 3.41 4.28 3 4.97 3 Z',
  'M1.62 8.5 L14.38 8.5',
  'M4.25 10.75 L4.35 10.75 L4.35 10.85 L4.25 10.85 Z',
  'M6.95 10.75 L7.05 10.75 L7.05 10.85 L6.95 10.85 Z',
];
